import { Component } from '@angular/core';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterCheckboxType } from './covance-filter-checkbox-type';

@Component({
    selector: 'covance-filter-checkbox-type',
    template: require('./covance-filter-checkbox-type.component.html'),
    styles: [require('./covance-filter-checkbox-type.component.scss')]
})
export class CovanceFilterCheckboxTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterCheckboxType> {
    constructor(filterType: CovanceFilterCheckboxType) {
        super(filterType);
    }

    public getCheckboxIcon() {
        return this.fieldVal.value ? 'check_box' : 'check_box_outline_blank';
    }

    public onClick() {
        this.fieldVal.value = !this.fieldVal.value;
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }
}